import { render, staticRenderFns } from "./Reactivate.vue?vue&type=template&id=6826f5ea&"
import script from "./Reactivate.vue?vue&type=script&lang=js&"
export * from "./Reactivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports